var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-path": "stroke",
    x: 1,
    y: 1,
    width: 18,
    height: 3,
    rx: 1,
    stroke: "#1D1D46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-path": "stroke",
    x: 1,
    y: 6,
    width: 18,
    height: 3,
    rx: 1,
    stroke: "#1D1D46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-path": "stroke",
    x: 1,
    y: 11,
    width: 18,
    height: 3,
    rx: 1,
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.97ddbcfb7af41e3d09b9bca621d211e6.svg";
export { ForwardRef as ReactComponent };